<div *ngIf="!isEdit" class="accordion-item">
  <h3 class="accordion-header" id="headingOne">
    <button class="accordion-button" (click)="showCredentials = !showCredentials"
      [ngClass]="{'collapsed':!showCredentials}" type="button" data-bs-toggle="collapse"
      data-bs-target="#INSCredentials" aria-expanded="true" aria-controls="INSCredentials">
      <span>Client Credentials</span>
      <div class="arrow"></div>
    </button>
  </h3>
  <div id="INSCredentials" *ngIf="credentialsForm" class="accordion-collapse collapse "
    [ngClass]="{'show':showCredentials}" aria-labelledby="INSCredentials" [formGroup]="credentialsForm">
    <div class="accordion-body">

      <div class="row">
        <div class="col-3 mb-3">
          <label for="INSClid" class="form-label">Client ID</label>
          <input autocomplete="disabled" type="text" formControlName="clientId" id="INSClid" class="form-control"
            appPreventFirstSpace>
        </div>
        <div class="col-3 mb-3">
          <label for="INSSecret" class="form-label">Client Secret</label>
          <div class="position-relative client-copy">
            <input type="text" id="INSSecret" formControlName="clientSecret" class="form-control" appPreventFirstSpace>
            <a *ngIf="credentialsForm?.controls?.['clientSecret']?.value" class="copy-icon tool-wrap position-relative"
              (click)="copyMessage(credentialsForm?.controls?.['clientSecret']?.value)">
              <div class="custom-tooltip tooltip-top" role="tooltip">
                <div class="arrow"></div>
                <div class="tooltip-inner"> {{copyText}} </div>
              </div>
            </a>
          </div>
        </div>
        <div class="col-6 mb-3">
          <label for="INSUrl" class="form-label">URL</label>
          <input autocomplete="disabled" type="text" id="INSUrl" formControlName="url" class="form-control" [ngClass]="{'is-invalid':(submitted && credentialsForm?.controls?.['url']?.errors?.['required']) ||
                    (credentialsForm?.controls?.['url']?.errors?.['validUrl'])}" appPreventFirstSpace>
          <span *ngIf="(credentialsForm?.controls?.['url']?.errors?.['validUrl'])" class="invalid-feedback d-block"
            tabindex="0">Invalid url</span>
          <span *ngIf="submitted && credentialsForm?.controls?.['url']?.errors?.['required']"
            class="invalid-feedback d-block" tabindex="0">This field is required</span>
        </div>
        <div class="col-3 mb-3">
          <label for="INSPayerID" class="form-label">From Date - To Date</label>
          <div [ngClass]="{'is-invalid':(submitted && credentialsForm?.controls?.['date']?.errors?.['required'])}">
            <app-datepicker_v2 formControlName="date" [field]="validity_date_v2" [disabled]="isDisabled">
            </app-datepicker_v2>

          </div>
          <span *ngIf="submitted && credentialsForm?.controls?.['date']?.errors?.['required']"
            class="invalid-feedback d-block" tabindex="0">This field is required</span>
        </div>

      </div>
    </div>
  </div>
</div>
<div *ngIf="isEdit" class="row-item">

  <div class="form-heading mb-3">
    <h3 class="before-none flex-border"><span>Client Credentials</span>
      <div class="heading-border"></div>
    </h3>
  </div>
  <div class="row justify-content-end">
    <div class="d-flex justify-content-end">
      <button class="btn btn-text regenerate-btn regenerate-btn-cs mb-4 mt-minus-10 with-loader"
        [ngClass]="{'show':showButtonLoader}" (click)="regenerateClientSecret()">
        <span class="text">Re generate</span>
        <span class="btn-loader"></span>
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-4">
      <div class="row mb-2">
        <div class="col-5"><label class="form-label">Client ID</label></div>
        <div class="col detail-view"> <span class="pointer">-</span>{{credentialsData?.clientId || 'NA'}}</div>
      </div>
      <div class="row">
        <div class="col-5"><label class="form-label">Validity</label></div>
        <div class="col detail-view"> <span class="pointer">-</span>{{credentialsData?.date || 'NA'}}</div>
      </div>
    </div>
    <div class="col-4">
      <div class="row mb-2">
        <div class="col-5"><label class="form-label">Client Secret</label></div>
        <div class="col detail-view"> <span class="pointer">-</span>
          <div *ngIf="!showButtonLoader" class="position-relative">{{credentialsData?.clientSecretMasked || 'NA'}}
            <a class="copy-icon tool-wrap position-relative" (click)="copyMessage(credentialsData?.clientSecret)">
              <div class="custom-tooltip tooltip-top" role="tooltip">
                <div class="arrow"></div>
                <div class="tooltip-inner"> {{copyText}} </div>
              </div>
            </a>
          </div>
          <div *ngIf="showButtonLoader" class="scroll-loader-container loader-for-text">
            <div class="scroll-loader"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="row">
        <div class="col-5"><label class="form-label">URL</label></div>
        <div class="col detail-view"> <span class="pointer">-</span>{{credentialsData?.url || 'NA'}}</div>
      </div>
    </div>

  </div>

</div>